var S = {};
var _learnq = _learnq || [];

jQuery(document).ready(function($) {


  S.size = {}
  S.size.all = function() {
    S.size.windowW = $(window).outerWidth();
    S.size.windowH = $(window).outerHeight();
    S.size.header = $(".header-interior").outerHeight();

    S.isDesktop = false;
    S.isTablet = false;
    S.isMobile = false;

    // console.log("window: " + S.size.windowW);

    if (S.size.windowW > 1024) {
      S.isDesktop = true;
    } else if (S.size.windowW > 767) {
      S.isTablet = true;
    } else {
      S.isMobile = true;
    }
  }

  S.vars = {}
  S.vars.loaderTime = 2210;
  /* SWIPER */
  S.swiper = {}

  S.swiper.init = function($s) {
    if (!$s) {
      $s = $("#page-content");
    }

    $s.find(".swiper-container").each(function() {
      var $swiper = $(this);
//       console.log($swiper)

      var swiper_args = new Array();

      if ($(this).hasClass("hero-swiper")) {
        var slideauto = false;
        var slidepagi = false;
//         console.log($(this).find(".swiper-slide").length)
        if ($(this).find(".swiper-slide").length > 1) {
          slideauto = {
            delay: 6000,
          };
          slidepagi = {
            el: '.swiper-pagination',
            clickable: true
          };
          swiper_args = {
            loop: true,
            autoplay: slideauto,
            simulateTouch: false,
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: slidepagi,
            navigation: false,
            disableOnInteraction: false,
            roundLengths: true,
            on: {
              init: function() {
                if ($("body").hasClass("body--index")) {
                  var $s = $(this)[0];
                  $s.autoplay.stop();
                  setTimeout(function() {
                    $s.autoplay.start();
                  }, S.vars.loaderTime + 1500)
                }
              }
            }
          }
        }
        else{
          swiper_args = {
            loop: false,
            draggable:false,
            autoplay: false,
            simulateTouch: false,
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: slidepagi,
            navigation: false,
            disableOnInteraction: false,
            roundLengths: true,
            on: {
              init: function() {
                if ($("body").hasClass("body--index")) {
                  var $s = $(this)[0];
                  $s.autoplay.stop();
                  setTimeout(function() {
                    $s.autoplay.start();
                  }, S.vars.loaderTime + 1500)
                }
              }
            },
            breakpoints: {
              768: {
                loop: false,
                draggable:false,
              }
            }
          }
        }


      } else if ($(this).hasClass("style-guide-swiper")) {
//         console.log($(this))
        if($('body').hasClass('body--page-community')){
          var parent = $(this);
          if($(this).find('.swiper-slide').length < 3){
            console.log($(this).find('.swiper-slide').length)
            swiper_args = {
              spaceBetween: 30,
              observer: true,
              observeParents: true,
              imulateTouch: false,
              autoplay: false,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              on: {
                init: function() {
                  var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                  if(parent.find('.swiper-slide').length==2){
                    parent.addClass('has-two-slides');
                  }
                  var $s = $(this)[0];
//                   if ($p.length) {
//                     var $tab = $p.find(".tab");
//                     if ($tab.length) {
//                       $tab.each(function() {
//                         $(this).click(function(e) {
//                           e.preventDefault();
//                           var i = $(this).index();
//                           // console.log("index: " + i);
//                           $s.slideToLoop(i);
//                         })
//                       })
//                       var $tab = $p.find(".tab:nth-child(1)");
//                       if ($tab.length) {
//                         $tab.addClass("active");
//                       }
//                     }
//                   }
                },
                slideChange: function () {
                  var i = $(this)[0].realIndex + 1;
                  console.log(i)
                  $($(this)[0].$el).find('.swiper-slide').removeClass('swiper-slide-active');
                  $($(this)[0].$el).find('.swiper-slide:eq('+$(this)[0].realIndex+')').addClass('swiper-slide-active');
                },
                slideChangeTransitionEnd:function () {
                  var i = $(this)[0].realIndex + 1;
                  console.log('slideChangeTransitionEnd',i)
                  $($(this)[0].$el).find('.swiper-slide').removeClass('swiper-slide-active');
                  $($(this)[0].$el).find('.swiper-slide:eq('+$(this)[0].realIndex+')').addClass('swiper-slide-active');
                },
              },
            }
          }
          else{
            swiper_args = {
            loop: true,
            observer: true,
            observeParents: true,
            autoplay: false,
            slidesPerView: 'auto',
            centeredSlides: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on: {
              init: function() {
                var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                //                 console.log($(this))
                var $s = $(this)[0];
                if ($p.length) {
                  var $tab = $p.find(".tab");
                  if ($tab.length) {
                    $tab.each(function() {
                      $(this).click(function(e) {
                        e.preventDefault();
                        var i = $(this).index();
                        // console.log("index: " + i);
                        $s.slideToLoop(i);
                      })
                    })
                    var $tab = $p.find(".tab:nth-child(1)");
                    if ($tab.length) {
                      $tab.addClass("active");
                    }
                  }
                }
              },
              slideChange: function () {
                var i = $(this)[0].realIndex + 1;
                var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                if ($p.length) {
                  var $tab = $p.find(".tab:nth-child("+i+")");
                  if ($tab.length) {
                    $tab.parent().find(".active").removeClass("active");
                    //$('.shop-full-look-placeholder.desktop-only').hide('fast');
                    $tab.addClass("active");
                    //$('.shop-full-look-placeholder.desktop-only').show('fast');
                  }
                }
              },
            },
          }
          }
        }
        else{
          swiper_args = {
            loop: true,
            observer: true,
            observeParents: true,
            autoplay: false,
            slidesPerView: 'auto',
            centeredSlides: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on: {
              init: function() {
                var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                //                 console.log($(this))
                var $s = $(this)[0];
                if ($p.length) {
                  var $tab = $p.find(".tab");
                  if ($tab.length) {
                    $tab.each(function() {
                      $(this).click(function(e) {
                        e.preventDefault();
                        var i = $(this).index();
                        // console.log("index: " + i);
                        $s.slideToLoop(i);
                      })
                    })
                    var $tab = $p.find(".tab:nth-child(1)");
                    if ($tab.length) {
                      $tab.addClass("active");
                    }
                  }
                }
              },
              slideChange: function () {
                var i = $(this)[0].realIndex + 1;
                var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                if ($p.length) {
                  var $tab = $p.find(".tab:nth-child("+i+")");
                  if ($tab.length) {
                    $tab.parent().find(".active").removeClass("active");
                    //$('.shop-full-look-placeholder.desktop-only').hide('fast');
                    $tab.addClass("active");
                    //$('.shop-full-look-placeholder.desktop-only').show('fast');
                  }
                }
              },
            },
          }
        }
          
      } else if ($(this).hasClass("circular-swiper")) {
        swiper_args = {
          loop: true,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          roundLengths: true,
        }
      } else if ($(this).hasClass("styling-session__locations")) {
        swiper_args = {
          loop: false,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          roundLengths: true,
          navigation: {
             nextEl: '.swiper-button-next',
             prevEl: '.swiper-button-prev',
           },
        }
      } else if ($(this).hasClass("featured-products-swiper")) {
        swiper_args = {
          loop: false,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          roundLengths: true,
        }
      } else {
        swiper_args = {
          slidesPerView: 'auto',
          centeredSlides: false,
          roundLengths: true,
          loop: false,
          preventClicks: false,
        }
      }

      // mySwiper.slideTo(index, speed, runCallbacks);

      var $t = $(this);
      // $t.imagesLoaded(function() {
      S.swiper.destroy($t);
//       console.log($t)

      var swiper = new Swiper($t, swiper_args);
      
        /*
        if ($("body").hasClass("body--index")) {
          swiper.autoplay.stop();
          setTimeout(function() {
            swiper.autoplay.start();
          }, S.vars.loaderTime + 1000)
        } */
        $t.removeClass("unloaded");
      // })


    });
  }

  S.swiper.update = function(swiper) {
    swiper.update();
  }

  S.swiper.onInit = function(swiper) {
    S.swiper.onSlideChangeStart(swiper);
  }

  S.swiper.slideStart = function(swiper) {
    var i = $(".swiper-slide-active").attr("data-swiper-slide-index");
    $(".slide-current").text(i);
  }

  S.swiper.onSlideChangeStart = function(swiper) {
    console.log("::: on slide change start");
    console.log("current index: " + swiper.realIndex);

  }


  S.swiper.destroy = function($t) {
    if ($t.attr("id") == "related") {
      console.log("this is related mode");
      if (S.swiper.relatedSwiper) {
        console.log("found related swiper, destroy it");
        S.swiper.relatedSwiper.destroy();
        delete S.swiper.relatedSwiper;
      }
    }
    $t.find('.swiper-wrapper').removeAttr('style');
    $t.find('.swiper-slide').removeAttr('style');
  }







  S.scroll = {}
  S.scroll.action = function() {
    var scroll = $(window).scrollTop();
    var $h = $(".header");


    if (scroll > 10 && !$h.hasClass("header--scrolled")) {
      $h.addClass("header--scrolled");
    } else if (scroll <= 10 && $h.hasClass("header--scrolled")) {
      $h.removeClass("header--scrolled");
    }
  }

  S.scroll.enable = function() {
    bodyScrollLock.clearAllBodyScrollLocks()
    $("body").removeClass("scroll-disabled")
    console.log("scroll enable!")

  }

  S.scroll.disable = function($t) {
    // bodyScrollLock.disableBodyScroll($t);

    bodyScrollLock.disableBodyScroll($t, {
     allowTouchMove: el => {
       while (el && el !== document.body) {
         if (el.getAttribute("body-scroll-lock-ignore") !== null) {
           return true
         }
         el = el.parentNode
       }
     }
   })

   $("body").addClass("scroll-disabled")
//    console.log("scroll disabled!");
   // $("html, body").addClass("disable-scroll-zoom");
  }

  S.share = {}

  S.share.links = function($s) {
    if ($s == null) {
      $s = $("body");
    }

    $s.find('a.share-facebook').click(function(e) {
      e.preventDefault();
      var $t = $(this);
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + S.share.url($t),"","width=640, height=320");
    });

    $s.find('a.share-twitter').click(function(e) {
      e.preventDefault();
      var $t = $(this);
      var $p = $t.parent();

      var url = S.share.url($t);
      var len = url.length;

      var via = $t.attr("data-via");
      if (via) {
        len = len +  5 + via.length;
        via = "&via=" + via;
      } else {
        via = '';
      }
      window.open("https://twitter.com/intent/tweet?url=" + url+via,"",'width=640,height=400');

    });


    $s.find("a.share-linkedin").click(function(e) {
      e.preventDefault();
      var $t = $(this);
      window.open("https://www.linkedin.com/shareArticle?mini=true&url=" + S.share.url($t),"",'width=640,height=400');
    })

    $s.find("a.share-pinterest").click(function(e) {
      e.preventDefault();
      $("#pinit-btn [data-pin-href]").trigger("click");
    })
  }

  S.share.url = function($t) {
    if ($t.length && $t.parents(".share").first().attr("data-href")) {
      var url = $t.parents(".share").first().attr("data-href");
      console.log("share url: " + url);
    } else {
      var url = window.location.href;
      console.log("share url backup: " + url);
    }

    return encodeURIComponent(url);
  }


  S.loader = {}
  S.loader.animationData = {"v":"5.6.5","fr":29.9700012207031,"ip":0,"op":67.0000027289659,"w":1920,"h":1080,"nm":"argent loader_option_2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"argent loader_option_2 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-25.749,-0.004],[-0.001,25.754],[25.754,0.001],[0.001,-25.754],[0,0]],"o":[[25.754,0.001],[0.001,-25.754],[-25.754,-0.001],[0,0],[0.007,25.749]],"v":[[-0.002,46.632],[46.632,0.002],[0.002,-46.632],[-46.632,-0.002],[-46.632,0.008]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[754.133,777.998],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.739,0.739],"y":[1,1]},"o":{"x":[0.79,0.79],"y":[0,0]},"t":15,"s":[0,0]},{"i":{"x":[0.331,0.331],"y":[1,1]},"o":{"x":[0.264,0.264],"y":[0,0]},"t":24.819,"s":[140,140]},{"i":{"x":[0.739,0.739],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"t":33,"s":[100,100]},{"i":{"x":[0.565,0.565],"y":[1,1]},"o":{"x":[0.645,0.645],"y":[0,0]},"t":52.819,"s":[100,100]},{"t":61.0000024845809,"s":[0,0]}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.129,"y":1},"o":{"x":0.449,"y":0},"t":4,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-129.844,-284.632],[-129.167,-284.618],[-51.156,-284.618],[-51.821,-284.632]],"c":true}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":14.901,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-129.844,-284.632],[51.833,284.632],[129.844,284.632],[-51.821,-284.632]],"c":true}]},{"i":{"x":0.674,"y":1},"o":{"x":0.69,"y":0},"t":42.406,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-129.844,-284.632],[51.833,284.632],[129.844,284.632],[-51.821,-284.632]],"c":true}]},{"t":52.0000021180034,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[52.155,285.368],[51.833,285.375],[129.634,285.375],[129.968,285.368]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":1.887,"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":180,"ix":3},"m":2,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[988.434,255.226],"ix":2},"a":{"a":0,"k":[-94.222,-284.774],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":306.000012463636,"st":0,"bm":0}],"markers":[]};
  S.loader.params = {
      container: document.getElementById('lottie'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: S.loader.animationData
  };

  S.loader.init = function() {

    var $pop = $(".loader.argent-loader");
    // console.log("loader length: " + $pop.length);
    if ($pop.length) {
      var cookiename = 'argent_loader_cookie';
      var cookie1 = Cookies.get(cookiename);
      var skipCookie = false;
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: 1,
          path: '/'
        });


        setTimeout(function() {
          $pop.addClass("active");
          if ($pop.hasClass("alt")) {
            lottie.loadAnimation(S.loader.params);
          }
          // return;

          setTimeout(function() {
            $pop.removeClass("active");
            $pop.remove();
            setTimeout(function() {
              // return
              $("body").removeClass("init");
              S.content.cookieBar();
              setTimeout(function() {
                S.content.emailPop();
              }, 600)
            }, 200)

          }, S.vars.loaderTime);
        }, 1000)


      } else {
        $("body").removeClass("init");
      }
    }
  }


  S.content = {}

  S.content.emailPop = function() {
    var $pop = $(".newsletter-pop");
    // console.log("pop length: " + $pop.length);
    if ($pop.length) {
      // console.log("--- list.cookie");
      var cookiename = 'argent_emailpop_cookie';
      var cookie1 = Cookies.get(cookiename);
      var skipCookie = false;
      // console.log("cookie: " + cookie1);
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: 14,
          path: '/'
        });

        $pop.addClass("active").find(".sm-x-close").click(function(e) {
          $(".newsletter-pop").removeClass("active");
        });
      } else {
        // console.log('cookie found: ' + Cookies.get(cookiename));
      }
    }
  }

  S.content.cookieBar = function() {
    var $pop = $(".cookie-bar");
    // console.log("pop length: " + $pop.length);
    if ($pop.length) {
      // console.log("--- list.cookie");
      var cookiename = 'argent_acceptance_cookie';
      var cookie1 = Cookies.get(cookiename);
      var skipCookie = false;
      // console.log("cookie: " + cookie1);
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: 30,
          path: '/'
        });

        $(".cookie-bar").addClass("active").find(".sm-x-close").click(function(e) {
          $(".cookie-bar").addClass("closed");
        });
      } else {
        // console.log('cookie found: ' + Cookies.get(cookiename));
      }
    }
  }

  S.content.makeFilterTags = function() {
    var tags = '';
    var $f = $(".filters__body");
    // var url =
    if ($f.length) {
      /*
      $f.find(".filter__item--active[data-url]").each(function() {
        var url = $(this).attr("data-url").replace(/\/$/, "");
        // $f.attr("data-url", url);
      })
      */

      var url = $f.attr("data-url");
      $f.find(".filter__item--active[data-tag]").each(function() {
        tags = tags + '+' + $(this).attr("data-tag");
      })
      $f.find(".filter__item--active[data-sort]").each(function() {
        tags = tags + '?sort_by=' + $(this).attr("data-sort");
      })


      var $close = $f.find(".close-btn");

      if (tags == '') {
        if (!$close.hasClass("hide")) {
          $close.addClass("hide");
        }
      } else {
        if ($close.hasClass("hide")) {
          $close.removeClass("hide");
        }
      }

      $close.attr("href", url + "/" + tags);
    }

  }



  S.kit = {}

  S.kit.checkSectionErrors = function(name, $kit_pagi) {
    var names = name.split(","), errors = false, results = 0;
    if (names.includes("first_name")) {
      var error_msg = "Please provide all details"
    } else if (names.length > 1) {
      var error_msg = 'Oops, you left out some answers'
    } else {
      var error_msg = 'Please pick at least one answer'
    }

    var error = false;

    for (var a = 0; a < names.length; a++) {
      results = $("#"+names[a]+":checked").length;
      if (results == 0) {
        results = $("#"+names[a]+"[type=hidden]").val() ? 1 : 0
      }
      if (results == 0) {
        results = $("#"+names[a]+"[type=text]").val() ? 1 : 0
      }
      if (results == 0) {
        results = $("select#kit_"+names[a]).val() ? 1 : 0
      }

      if (results == 0) {
        error = true;
        console.log(names[a])
        console.log($("[data-question='"+names[a]+"']").length)
        $("[data-question='"+names[a]+"']").addClass("error");
      }
    }

    if (error == true) {
      $kit_pagi.prepend('<div class="error">'+error_msg+'</div>');
      setTimeout(function() {
        $kit_pagi.find(".error").addClass("inactive");
        setTimeout(function() {
          $("[data-question].error").removeClass("error");
          $kit_pagi.find(".error").remove();
        }, 500)
      }, 2000)
      // return true
    }

    return error
  }

  S.kit.thankyou = function() {
    var $s = $(".starter-kit-body");
    /*
    var html = `<div class="kit-thankyou">
    <h2 class="kit-thankyou-title type-b">Nice Work!</h2>
    <div class="kit-thankyou-text type-c">The welcome kit is on its way to you.</div>
    <a href="/collections/all" class="btn reverse">Keep Shopping</a>
    </div>`
    */
    var html = $("#kit-thankyou-html").html();
    $s.append(html);
    setTimeout(function() {
      $s.addClass("completed")

      setTimeout(function() {
        $(".starter-kit-wrapper").scrollTop(0);
        $s.find(".kit-progress,form,.step-login").remove();
      }, 10)

    }, 1500)

    // $s.find(".kit-progress,form,.step-login").remove();

  }


  S.kit.progress = function(up_device_count) {
    if (!up_device_count) {
      up_device_count = false;
    }
    var $active = $(".kit-survey-step.active"), step = $active.index() + 1, $bar = $(".kit-progress-indicator"), device_step = step;
    if (step > 4 || up_device_count == true) {
      device_step++;
    }
    // console.log("step: " + step);
    // console.log("device-step: " + device_step);
    $(".kit-pages.desktop-only .step").text(step);
    $(".kit-pages.device-only .device-step").text(device_step)
    $bar.attr("data-step", step);
    $bar.attr("data-device-step", device_step);


    $(".starter-kit-wrapper").scrollTop(0);
    var survey = S.kit.makeSurveyAnswers();
    console.log(survey);
  }


  S.kit.pagi = function($s) {
    $s.find(".shopify-section > .kit-survey-step").unwrap();

    $s.find(".x-close,.overlay-blur").click(function(e) {
      e.preventDefault();
      $(".starter-kit-survey").removeClass("active");
      S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
    })

    $s.find(".kit-pagi-prev:not(.kit-pagi-prev-sub)").click(function(e) {
      e.preventDefault();
      console.log("prev clicked");
      var $active = $(this).parents(".kit-survey-step.active").first(), active = $active.index(), up_device_count = false;
      if (active == 4) {
        // the step after fit
        up_device_count = true
      }

      if (active >= 1) {
        var $next = $(".kit-steps .kit-survey-step:nth-child("+active+")");
        if ($next.length) {
          $active.removeClass("active");
          $next.addClass("active");
          S.kit.progress(up_device_count);
        }
      } else {
        var $next = $(".kit-survey-step.step-login");
        if ($next.length) {
          $active.removeClass("active");
          $next.addClass("active");
        }

      }
    })

    $s.find(".kit-pagi-next:not(.kit-pagi-next-sub)").click(function(e) {
      e.preventDefault();
      // console.log("next clicked");
      // var survey = S.kit.makeSurveyAnswers();
      // console.log(survey);
      // return
      var $active = $(this).parents(".kit-survey-step.active").first(),
      active = $active.index() + 2,
      name = $(this).attr("data-name"),
      $kit_pagi = $active.find(".kit-pagi");

      if (name) {
        var hasErrors = S.kit.checkSectionErrors(name, $kit_pagi);
        if (hasErrors) {
          // console.log("hasErrors! " + hasErrors )
          return
        }
      }

      if ($(this).attr("type") == "submit") {
        // do the submission
        // console.log("final submit!");
        // S.kit.thankyou();
        $(".kit-pagi-next[type='submit']").text("Submitting...");
        $("form#starter-kit-form").submit();

      } else {
        if (active <= $(".kit-steps .kit-survey-step").length) {
          var $next = $(".kit-steps .kit-survey-step:nth-child("+active+")");
          if ($next.length) {
            $active.removeClass("active");
            $next.addClass("active");
            S.kit.progress();
          }
        } else {
          // console.log("skipped active!")
        }
      }



    })

    $s.find(".kit-pagi-prev-sub").click(function(e) {
      e.preventDefault();
      var $kit_pagi = $(this).parents(".kit-pagi").first(),
      $section = $(this).parents(".kit-survey-step").first();
      $active = $section.find(".kit-sub-section.active"),
      $next = $section.find(".kit-sub-section:not(.active)"),
      $gobacksub = $(this),
      $goback = $kit_pagi.find(".kit-pagi-prev:not(.kit-pagi-prev-sub)"),
      $nextbtnsub = $kit_pagi.find(".kit-pagi-next.kit-pagi-next-sub"),
      $nextbtn = $kit_pagi.find(".kit-pagi-next:not(.kit-pagi-next-sub)");

      if ($next.length) {
        $active.removeClass("active");
        $next.addClass("active");

        // hide the actual next button and make the sub one active
        $nextbtnsub.removeClass("device-inactive");
        $nextbtn.addClass("device-inactive");

        // hide the sub go back button and show actual go back button
        $gobacksub.addClass("device-inactive");
        $goback.removeClass("device-inactive");

        S.kit.progress(); // adjust progress bar
      }

    })

    $s.find(".kit-pagi-next-sub").click(function(e) {
      e.preventDefault();
      // this is for the device version where this section is two pages in device
      // this button is in the first sub-section of the section, clicking it will take you to the second sub-section

      var $kit_pagi = $(this).parents(".kit-pagi").first(),
      $section = $(this).parents(".kit-survey-step").first();
      $active = $section.find(".kit-sub-section.active"),
      $next = $section.find(".kit-sub-section:not(.active)"),
      name = $(this).attr("data-name")
      $gobacksub = $kit_pagi.find(".kit-pagi-prev-sub"),
      $goback = $kit_pagi.find(".kit-pagi-prev:not(.kit-pagi-prev-sub)"),
      $nextbtnsub = $(this),
      $nextbtn = $kit_pagi.find(".kit-pagi-next:not(.kit-pagi-next-sub)");

      var hasErrors = S.kit.checkSectionErrors(name, $kit_pagi);
      if (hasErrors) {
        return
      }

      if ($next.length) {
        $active.removeClass("active");
        $next.addClass("active");

        // hide the sub next button and make the actual one active
        $nextbtnsub.addClass("device-inactive");
        $nextbtn.removeClass("device-inactive");

        // hide the actual go back button and show the sub go back button that takes you back to the first sub section
        $gobacksub.removeClass("device-inactive");
        $goback.addClass("device-inactive");

        S.kit.progress(true); // up device count
      }
    })


    $s.find("button.kit-guest-continue").click(function(e) {
      e.preventDefault();
      var $e = $("#kit-email"), $ep = $(".field.kit-email");
      var email = $e.val();
      if (!email) {
        $e.addClass("error");
        return
      }
      console.log("try to update name email!")
      $("form#starter-kit-form input[name='email']#kit_email").val(email);
      var $next = $(".kit-steps .kit-survey-step:nth-child(1)");
      if ($next.length) {
        $(".kit-survey-step.step-login.active").removeClass("active");
        $next.addClass("active");
        S.kit.progress();
      }
    })


    /*
    $("#kit_height_ft,#kit_height_in").change(function() {
      var ft = $("#kit_height_ft").val();
      var inches = $("#kit_height_in").val();
      var calculatedHeight = ft + "' " + inches + '"';
      $("#height").val(calculatedHeight);
    }) */

    $s.find(".kit-answers-select").each(function() {
      $(this).find(".answer-trigger").click(function(e) {
        e.preventDefault();
        var $t = $(this).siblings(".fields").first();
        if ($t.hasClass("active")) {
          $t.removeClass("active");
          $(this).removeClass("active");
        } else {
          $t.addClass("active");
          $(".kit-answers-select .answer-trigger.active").trigger("click"); // close other actives
          $(this).addClass("active");
        }
      })

      $(this).find(".answer-input").click(function() {
        var $p = $(this).parents(".answer-select-block").first();
        val = $(this).val();
        $p.find(".selected-answer").text(val);
        if ($(this).attr("name") == "height_in" || $(this).attr("name") == "height_ft") {
          var ft = $("input[name='height_ft']:checked").val();
          if (ft) {
            var inches = $("input[name='height_in']:checked").val();
            if (!inches) {
              inches = 0;
            }
            var calculatedHeight = ft + "' " + inches + '"';
            $("#height").val(calculatedHeight);
          }

        }
        $p.find(".answer-trigger").trigger("click");
      })
    })

    $s.find("input[required]").focus(function() {
      $(this).removeClass("error");
      //$(this).parents(".field.error").first().removeClass("error");
    })

  }

  S.kit.getCheckboxValues = function(id) {
    var checkboxes = document.getElementsByName(id);
    var vals = "";
    var question = checkboxes[0].dataset.question;
    for (var i=0, n=checkboxes.length;i<n;i++)
    {
        if (checkboxes[i].checked)
        {
            vals += ", "+checkboxes[i].value;
        }
    }
    if (vals) vals = vals.substring(2)
    else vals = ' - ';

    return { q: question, a: vals }
  }

  S.kit.getRadioValue = function(id) {
    var checkboxes = document.getElementsByName(id);
    var question = checkboxes[0].dataset.question;
    var vals = "";
    for (var i=0, n=checkboxes.length;i<n;i++)
    {
        if (checkboxes[i].checked)
        {
            val = checkboxes[i].value;
            return { q: question, a: val }
        }
    }

    return { q: question, a: " - " }

  }

  S.kit.getTextValue = function(id) {
    var text = document.getElementsByName(id)[0];
//     console.log(text);
    var question = text.dataset.question;
    var val = text.value
    if (val) {
      return { q: question, a: val }
    }
    return { q: question, a: " - " }
  }

  S.kit.makeSurveyAnswers = function() {
    // e.target is the same as our form
    var images = [];
    var occasion = S.kit.getCheckboxValues("occasion[]");
    var style = S.kit.getCheckboxValues("style[]");
    var need = S.kit.getCheckboxValues("need[]");
    var colors = S.kit.getCheckboxValues("colors[]");
    var fit = S.kit.getCheckboxValues("fit[]");
    var tops_size = S.kit.getRadioValue("tops_size");
    var bottom_size = S.kit.getRadioValue("bottom_size");
    var arms = S.kit.getRadioValue("arms");
    var shoulders = S.kit.getRadioValue("shoulders");
    var torso = S.kit.getRadioValue("torso");
    var legs = S.kit.getRadioValue("legs");
    var shape = S.kit.getRadioValue("shape");
    var tone = S.kit.getRadioValue("tone");
    var height = S.kit.getTextValue("height");

    var survey = [
      {
        name: occasion.q,
        value: occasion.a,
      },
      {
        name: style.q,
        value: style.a,
      },
      {
        name: need.q,
        value: need.a,
      },
      {
        name: colors.q,
        value: colors.a,
      },
      {
        name: fit.q,
        value: fit.a,
      },
      {
        name: tops_size.q,
        value: tops_size.a,
      },
      {
        name: bottom_size.q,
        value: bottom_size.a,
      },
      {
        name: height.q,
        value: height.a
      },
      {
        name: arms.q,
        value: arms.a,
      },
      {
        name: shoulders.q,
        value: shoulders.a,
      },
      {
        name: torso.q,
        value: torso.a,
      },
      {
        name: legs.q,
        value: legs.a,
      },
      {
        name: shape.q,
        value: shape.a,
      },
      {
        name: tone.q,
        value: tone.a,
      },
      ...images.map((url, i) => ({
        name: `Image ${i + 1}`,
        value: images[i],
      }))
    ]

    return survey
  }

  S.kit.init = function(el) {

    if (!el.hasClass("logged-in") && window.location.href.indexOf("checkout_url") == -1) {
      window.history.pushState( {} , '', '/pages/starter-kit?checkout_url=/pages/starter-kit' );
    }

    new Shopify.CountryProvinceSelector('kit_country', 'kit_state', {hideElement: 'kit_state'});
    // var defaultState = $('.province-select[data-default]').attr("data-default"); $('.province-select > option').each(function(){ if ('[value]' == defaultState){ $(this).attr('selected', 'selected'); } });
    console.log($("#kit_state option"))
    $("#kit_state option[value='Alaska']").remove();
    $("#kit_state option[value='Hawaii']").remove()
    $("#kit_state option[value='American Samoa']").remove();
    $("#kit_state option[value='Guam']").remove();
    $("#kit_state option[value='Northern Mariana Islands']").remove();
    $("#kit_state option[value='Puerto Rico']").remove();
    $("#kit_state option[value='Virgin Islands']").remove();
    setTimeout(function() {
      $('.province-select[data-default]').each(function() {
        var defaultState = $(this).attr("data-default");
        if (defaultState != "State") {
          $(this).val(defaultState);
        }

      })
    }, 500)

    if (!$(".step-login").length) {
      S.kit.progress(el);
    }

    S.kit.pagi(el);
    S.kit.form(el);


    $(".kit-video").each(function() {
      var $video = document.getElementById("kitvideo");
      $(this).find(".video-control").click(function(e) {
        var $video = document.getElementById("kitvideo");
        if ($(this).hasClass("playing")) {
          $video.pause();
          $(this).removeClass("playing");
        } else {
          $(this).addClass("playing");
          $video.play();
        }
      })
    })




    $("a[href='#start']").click(function(e) {
      e.preventDefault();
      $(".starter-kit-survey").addClass("active");
      S.scroll.disable($(".starter-kit-survey [body-scroll-lock-ignore]"));
    })

    // this has to be done BEFORE the checkout_url is added
    // console.log("document.referrer: " + document.referrer)
    var hash = window.location.hash;
    if (hash == "#start" || document.referrer.indexOf("oxiapps.com") > -1 || document.referrer.indexOf("social-login") > -1) {
      S.scroll.disable(el.find("[body-scroll-lock-ignore]"));
      el.addClass("active");
    }
  }

  S.kit.form = function(el) {
    // S.kit.thankyou();


    // e.g. https://gifted-allen-c9825f.netlify.app
    var NETLIFY_URL = 'https://silly-ptolemy-de369c.netlify.app';
    // var NETLIFY_URL  = 'https://gifted-allen-c9825f.netlify.app';
    // You can make track state like in React, but you'll have to manually update the nodes.
    let processing = true;
    let images = [];

    /*

    if (window.location.hash == "#test") {
      console.log(window.location.hash )
      setTimeout(function() {
        S.kit.thankyou();
      }, 6000)

    } */



    // this is a test for get-order
    /*
    if (window.location.hash == "#test") {
      console.log("get order test");
      fetch(`${NETLIFY_URL}/.netlify/functions/create-final-order`, {
        method: "POST",
        // body: "",
        // If you want the user to type their email before reaching Braintree,
        // you can specify the email here. This will load up their previous payment methoods.
        body: JSON.stringify({ order_id: "2340616634505" }),
      }).then((r) => r.json())
      .then(({ order }) => {
        // Initialize Braintree
        console.log(order)
      });
    }
    */

    /*
    if (window.location.hash == "#test") {
      console.log("get order test");
      try {
        fetch(`${NETLIFY_URL}/.netlify/functions/update-final-order`, {
          method: "POST",
          // body: "",
          // If you want the user to type their email before reaching Braintree,
          // you can specify the email here. This will load up their previous payment methoods.
          body: JSON.stringify({ order_id: "2351997157513" }),
        }).then((r) => r.json())
        .then(({ order }) => {
          // Initialize Braintree
          console.log(order)
        });
      } catch (err) {
        console.log(err)
        // throw new Error("Invalid order_id");
      }

    } */




    // return



    let braintreeInstance;
    let deviceData;



    // Braintree needs a server-generated token
    fetch(`${NETLIFY_URL}/.netlify/functions/client-token`, {
      method: "POST",
      body: "",
      // If you want the user to type their email before reaching Braintree,
      // you can specify the email here. This will load up their previous payment methoods.
      // body: JSON.stringify({ email: "janedoe@gmail.com" }),
    })
      .then((r) => r.json())
      .then(({ clientToken }) => {
        // Initialize Braintree
        window.braintree.dropin.create(
          {
            authorization: clientToken,
            container: document.querySelector("#dropin-container"),
            dataCollector: {
              kount: false
            }
          },
          function (createErr, instance) {
            braintreeInstance = instance;
            deviceData = instance._dataCollector._instance.deviceData;
          }
        );
      });



    // Cloudinary


    var widget = cloudinary.createUploadWidget({
      cloudName: "argentwork",
      uploadPreset: "vtw7id6z",
      resourceType: 'image',
      singleUploadAutoClose: true,
      maxFiles: 1,
      inlineContainer: "#kit-photo-uploader"
    }, (err, result) => {
      if (!err && result && result.event === "success") {
        images = [...images, result.info.secure_url];
        // console.log("success!")
        // console.log(images)
      } else {
        // console.log(err)
      }
    });

    var openWidget = (file) => {
    //   console.log("openWidget!")
      // console.log(file)
      images = [];
      widget.open(null, {files: [file]});
    }

    var uploadButton = el.find('.UploadButton');
    uploadButton.click(function(e) {
      images = [];
      widget.open();
    })

    $("input[type=file].kit-photo-upload").each(function() {
      $(this).on("change", function(e){
        if ($(this)[0].files && $(this)[0].files.length > 0 ) {
            var reader = new FileReader();
            reader.onload = function (e) {
              $('.kit-photo-circle').addClass("uploaded").css("backgroundImage", 'url(' + e.target.result + ')')
            };

            reader.readAsDataURL($(this)[0].files[0]);
            $(".step-photo .kit-pagi-next").text("Next Step");
            // move the actual upload to form submission handler?
            openWidget($(this)[0].files[0])

        } else {
          $('.kit-photo-circle').removeClass("uploaded").css("backgroundImage", "");
          $(".step-photo .kit-pagi-next").text("Skip Step");
          // $(this).siblings(".filename").remove();
        }
      });
    })

    //return;







    // Form submission
    var handleSubmit = (e) => {
      e.preventDefault();
      $("[data-braintree-id=toggle]").removeClass("active");


      var survey = S.kit.makeSurveyAnswers()


      // console.log(...images);
      // return;

      var inputs = e.target.elements;
//       console.log(inputs);


      const surveyObject = Object.fromEntries(
        new Map(survey.map(x => ([x.name, x.value])))
      );

      // surveyObject["Starter Kit RMA"] = false

      // console.log(surveyObject);


      // console.log(_learnq);

      /*
      if (window.location.hash == "#test") {
        S.kit.thankyou();
        return
      } */

      /*
      const payload = {
        email: inputs.kit_email.value,
        first_name: inputs.first_name.value,
        last_name: inputs.last_name.value,
        address1: inputs.address1.value,
        address2: inputs.address2value,
        city: inputs.city.value,
        state: inputs.kit_state.value,
        zip: inputs.zip.value,
        country: inputs.kit_country.value,
        // phone: inputs.phone.value,
        survey: survey
      };

      console.log(payload)

      return */



      return braintreeInstance.requestPaymentMethod().then((paymentMethod) => {
        console.log(paymentMethod);
        const token = paymentMethod.nonce;
        const paymentCardType = paymentMethod.details.cardType;
        const paymentEnding = paymentMethod.details.lastFour;
        const deviceData = paymentMethod.deviceData;

        console.log(`Created token ${token}`);

        // S.kit.thankyou();


        /*
        // moved to later, only on successful submission
        _learnq.push(['identify', {
        '$email' : inputs.email.value,
        ...surveyObject
        }]);

        _learnq.push(['track', 'Starter Kit Submitted', surveyObject]);
        */

        // console.log(deviceData)



        const payload = {
          token,
          email: inputs.kit_email.value,
          first_name: inputs.first_name.value,
          last_name: inputs.last_name.value,
          address1: inputs.address1.value,
          address2: inputs.address2.value,
          city: inputs.city.value,
          state: inputs.kit_state.value,
          zip: inputs.zip.value,
          country: inputs.kit_country.value,
          // phone: inputs.phone.value,
          survey: survey,
          paymentMethod: paymentCardType,
          paymentEnding: paymentEnding,
          deviceData: deviceData
        };


        console.log("Sending to Netlify function...", payload);
        // return


        return fetch(`${NETLIFY_URL}/.netlify/functions/create-kit-order`, {
          method: "POST",
          body: JSON.stringify(payload),
        })
        .then((res) => {
          return res.json().then((data) => {
            if (res.status === 200) {
              console.log("Created draft order", data);
              processing = false;
              S.kit.thankyou();
              _learnq.push(['identify', {
              '$email' : inputs.kit_email.value,
              ...surveyObject
              }]);

              _learnq.push(['track', 'Starter Kit Submitted', surveyObject]);

            } else {
              console.error(data);
              var err_msg = "Could not submit.";
              var err = data;

              /*
              if (err.verification) {
                if (err.verification.cvvResponseCode == "N" && err.verification.avsPostalCodeResponseCode == "N") {
                  err_msg = "Invalid CVV and Zipcode."
                } else if (err.verification.cvvResponseCode == "N") {
                  err_msg = "Invalid CVV."
                } else if (err.verification.avsPostalCodeResponseCode == "N") {
                  err_msg = "Invalid Zipcode."
                }
              } */
              $(".kit-pagi .error").remove();
              $(".kit-pagi-next[type='submit']").before('<div class="error">'+err_msg+'</div>');
              $("[data-braintree-id=toggle]").addClass("active");
              setTimeout(function() {
                $(".kit-pagi .error").remove();
                $(".kit-pagi-next[type='submit']").text("Finish Quiz");
              }, 2000);
            }
          });
        })
        .catch((err) => {
          processing = false;
          console.error(err);
          var err_msg = "Credit card could not be verified.";

          if (err.verification) {
            if (err.verification.cvvResponseCode == "N" && err.verification.avsPostalCodeResponseCode == "N") {
              err_msg = "Invalid CVV and Zipcode."
            } else if (err.verification.cvvResponseCode == "N") {
              err_msg = "Invalid CVV."
            } else if (err.verification.avsPostalCodeResponseCode == "N") {
              err_msg = "Invalid Zipcode."
            }
          }
          $(".kit-pagi .error").remove();
          $(".kit-pagi-next[type='submit']").before('<div class="error">'+err_msg+'</div>');
          $("[data-braintree-id=toggle]").addClass("active");
          setTimeout(function() {
            $(".kit-pagi .error").remove();
            $(".kit-pagi-next[type='submit']").text("Finish Quiz");
          }, 2000);
        });
      }).catch((err) => {
        processing = false;
        console.error(err);
        $(".kit-pagi-next[type='submit']").text('Finish Quiz');
      });

    };

    var form = el.find('form#starter-kit-form');
    form.submit(function(e) {
      handleSubmit(e);
    })


  }

  S.content.init = function($c) {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    $(".swiper-container .full-looks").each(function() {
      $("body").append($(this));
      // has to happen before swiper init so that there are no duplicates
      // this is for homepage only
    })

    $(".shopify-section").each(function() {
      var html = $(this).html().trim();
      if (html == "") {
        $(this).remove();
      }
    })

    if ($("body").hasClass("body--customers__login") && window.location.href.indexOf("checkout_url") > -1 && window.location.href.indexOf("starter-kit") > -1) {
      window.location.href = "/pages/starter-kit#start"
    }

    if ($(".starter-kit-survey").length) {
      S.kit.init($(".starter-kit-survey"));
    }

//     if (pn && pn.settings.tagSettings) {
//       $("[data-preorder-tag]").each(function() {
//         var id = $(this).attr("data-preorder-tag");
//         var result = pn.settings.tagSettings.filter(p => p.tag == id);
//         if (result && result.length) {
//           if ($(this).hasClass("cart-item__title")) {
//             $(this).after('<span class="preorder-label">Back order</span>')
//           } else {
//             $(this).before('<span class="preorder-label">Back order</span>')
//           }

//           if ($(this).siblings(".sizes-and-btn").find("button.quickshop-mode").length) {
//             $(this).siblings(".sizes-and-btn").find("button.quickshop-mode").text("Back order");
//           }
//         }
//       })
//       // console.log(pn.settings.singleProductSettings);
//     }

//     if (pn && pn.settings.singleProductSettings) {
//       $("[data-preorder-id]").each(function() {
//         var id = $(this).attr("data-preorder-id");
//         var result = pn.settings.singleProductSettings.filter(p => p.n == id);
//         if (result && result.length) {
//           $(this).after('<span class="cart-item__preorder">Back order</span>')
//         }
//       })
//       $("[data-preorder-pid]").each(function() {
//         var id = $(this).attr("data-preorder-pid");
//         var result = pn.settings.singleProductSettings.filter(p => p.p == id);
//         if (result && result.length) {
//           console.log("id: " + result.length);
//           $(this).before('<span class="preorder-label">Back order</span>')
//           if ($(this).siblings(".sizes-and-btn").find("button[type=submit]").length) {
//             $(this).siblings(".sizes-and-btn").find("button[type=submit]").text("Back order");
//           }
//         }
//       })
//       console.log(pn.settings.singleProductSettings);
//     }
    
    
    $("[data-product-preorder]").each(function() {
      var parent = $(this).attr("data-product-preorder");
      console.log($(this))
      $(this).parents('.product-item__info').find('.preorder-label').remove();
      $(this).parents('.product-item__info').find('.color-label-wrapper').after('<span class="preorder-label product-banner product-banner">'+window.theme.preorder_label+'</span>')
      if ($(this).siblings(".sizes-and-btn").find("button[type=submit]").length) {
        $(this).siblings(".sizes-and-btn").find("button[type=submit]").text(window.theme.preorder_btn_label);
      }
    })

    
    $("[data-parent-product-preorder] [data-product-color-preorder=true]").each(function() {
      var parent = $(this).attr("data-product-color-preorder");
      var l = '<span class="preorder-label product-banner product-banner">'+window.theme.preorder_label+'</span>';
      
      //       $(this).parents('.product-item__info').find('.product-banner--almost-gone').remove();
            $(this).parents('.product-item__info').find('.preorder-label').remove();
      if(parent==true || parent == 'true'){
//         console.log($(this))
        $(this).parents('.product-item__info').find('.col-two-wrapper').append(l);
        $(this).parents('.product-item__info').find('.color-label-wrapper').after(l);
//         console.log($(this).parents('.product-item__info').find('.col-two-wrapper'))
        //         
        if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
          $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text(window.theme.preorder_btn_label);
        }
      }
    })
    
    $("[data-product-color-preorder]").on('click',function(e) {
      var parent = $(this).attr("data-product-color-preorder");
      var pid = parseFloat($(this).attr('data-product-id'));
      var color_name = $(this).find('input').attr('data-option-value');
//       console.log(color_name)
      var almost_gone = JSON.parse($(this).parents('.colorway-color-label').attr('data-almost-gone'));
      $(this).parents('[data-product-id]').attr('data-product-id',pid)
      var l = '<span class="preorder-label product-banner">'+window.theme.preorder_label+'</span>';
//       console.log(almost_gone)
      $(this).parents('.product-item__info').find('.preorder-label').remove();
      if(parent==true || parent == 'true'){
//         console.log($(this).parents('.product-item__info').find('.product-banner--almost-gone'))
        if($(this).parents('.product-item__info').find('.product-banner--almost-gone').length>0){
          $(this).parents('.product-item__info').find('.product-banner--almost-gone').hide();
        }  
        $(this).parents('.product-item__info').find('.col-two-wrapper').append(l);
//         console.log($(this).parents('.product-item__info').find('.col-two-wrapper'))
        $(this).parents('.product-item__info').find('.color-label-wrapper').after(l);
        if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
          $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text(window.theme.preorder_btn_label);
        }
      }
      else{
        $(this).parents('.product-item__info').find('.product-banner--almost-gone[data-option-value !="'+color_name+'"]').attr("style", "display: none !important");
        if($(this).parents('.product-item__info').find('.product-banner--almost-gone').length>0 && almost_gone==true){
          $(this).parents('.product-item__info').find('.product-banner--almost-gone[data-option-value ="'+color_name+'"]').show();
        }
        else{
//           console.log(almost_gone)
          $(this).parents('.product-item__info').find('.product-banner--almost-gone[data-option-value !="'+color_name+'"]').attr("style", "display: none !important");
        }
        if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
          $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text('Add to Bag');
        }
      }
      
    })



    S.swiper.init($c);

    S.share.links($c);

    if ($("section.hero").length) {
      $(".header").addClass("reverse no-mobile-reverse");
    } else if ($(".page-account").length) {
      $(".header").addClass("reverse no-mobile-reverse");
    }
    $(".selected-size").click(function(e) {
      e.preventDefault();
      var $t = $(this).siblings(".option__values").first();
      if ($t.hasClass("active")) {
        $t.removeClass("active");
        $(this).removeClass("active");
      } else {
        $t.addClass("active");
        $(this).addClass("active");
      }
    })


    $(".option-value .option__input").click(function() {
      
      var $p = $(this).parents(".option");
      var $t = $p.find(".selected-val");
//       console.log($(this).parents('.quickshop-product-content').attr('data-variant-dict'))
//       var variant_json = ($(this).parents('.quickshop-product-content').attr('data-variant-dict')!=undefined)?$.parseJSON($(this).parents('.quickshop-product-content').attr('data-variant-dict')):[];
      var variant_json = $.parseJSON($(this).parents('[data-variant-dict]').attr('data-variant-dict'));
      var prod_title = ($(this).parents('[data-variant-dict]').attr('data-product-title'));
      var prod_id = parseFloat($(this).parents('[data-variant-dict]').attr('data-product-id'));
//       console.log(prod_id,prod_title)
      $(this).parent(".option-value").addClass("active").siblings(".active").removeClass("active");

      var $n = $p.find(".option-name-click,.selected-size.active");
      var val = $(this).attr("value");
//       console.log();
      
     

      // $n.text(val);
      if ($t.length) {
        $t.text(val);
        if ($t.hasClass("active")) {
          $t.trigger("click");
        }
      }

      if ($n.length) {
        if ($n.hasClass("active")) {
          $n.trigger("click");
        }
      }
      
      var selected_var = $.grep(variant_json, function( n, l ) {
        return (n.option1==val);
      });
      
      var $trigger = $(this).parents("form").find(".quick-add__button[data-size='"+val+"']");
      if ($trigger.length) {
        
        var preorder_tag2 = [];
        $.each(getDistinct(window.variant_metadata),function(i,n){
          if((n.id==prod_id && n.title ==prod_title ) && n.preorder_enable == "true" && n.entire_product==true){
            preorder_tag2.push(n);
          }
          else if(selected_var.length > 0){
            if(selected_var[0].options_with_values != undefined){
              if(n.option1==selected_var[0].options_with_values[0].value && n.preorder_enable == "true" && n.id==selected_var[0].id){
                preorder_tag2.push(n);
              }
            }
            else if(n.option1==selected_var[0].option1 && n.preorder_enable == "true" && n.id==selected_var[0].id){
              preorder_tag2.push(n);
            }
          }
        })
//         if (parseInt($trigger.attr("data-available")) <= 0) {
//           $(this).parents("form").first().find("button.quickshop-hover-add").text(window.theme.preorder_btn_label);
//         } else {
//           $(this).parents("form").first().find("button.quickshop-hover-add").text('Add to Bag');
//         }

//         console.log(preorder_tag2)
        $(this).parents('form').first().find('.product-banner').remove();
        if(preorder_tag2.length>0){
          var preorder_label = '<div class="product-banner preorder-label product-banner--warning product-banner--almost-gone" style="text-align: right;width: 100%;">'+window.theme.preorder_label+'</div>';
//           console.log($(this).parents('form').first().find('.color-labels'))
          $(this).parents('form').first().find('.color-labels').append(preorder_label);
          $(this).parents("form").first().find("button.quickshop-hover-add").text(window.theme.preorder_btn_label);
        } else {
          $(this).parents("form").first().find("button.quickshop-hover-add").text('Add to Bag');
        }
        
      }

    })

    if ($(".page-login").length) {
      console.log("hash: " + window.location.hash)
      if (window.location.hash == "#forgot") {
        $(".login-form").removeClass("show");
        $(".reset-password-form").addClass("show");
      }
    }


    $(".expandable-title").click(function(e) {
      e.preventDefault();
      var $t = $(this).parents(".expandable-text");
      if ($t.hasClass("active")) {
        $t.removeClass("active");
      } else {
        $t.siblings(".expandable-text.active").removeClass("active");
        $t.addClass("active");
      }
    })

    $(".sizeguide-tab").click(function(e) {
      e.preventDefault();
      var id = $(this).attr("data-id");
      var $p = $(this).parents(".sizeguide-section__sizecharts").find(".size-chart--" + id);
      if ($p.length) {
        if (!$(this).hasClass("active")) {
          $(this).addClass("active").siblings(".active").removeClass("active");
          $p.addClass("active").siblings(".active").removeClass("active");
        }
      }
    })

    $(".sizeguide-tab").first().trigger("click");

    if ($(".contact.support-page").length) {
      $(".support-tab[href='/pages/contact']").addClass("active");
    }

    $("[data-toggle=modal]").click(function(e) {
      e.preventDefault();
      var target = $(this).attr("data-target");
      var $t = $(target);
      S.scroll.disable($t.find("[body-scroll-lock-ignore]"));
      if ($t.length) {
        $t.addClass("active");
        if ($(".modal-resurva").hasClass("active")) {
          $("html, body").addClass("disable-scroll-notfixed");
        }
      }
    })

    $(".modal").each(function() {
      $(this).find(".overlay-blur,.x-close").click(function(e) {
        e.preventDefault();
        S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
        $(this).parents(".modal").removeClass("active show");
        if (!$(".modal-resurva").hasClass("active")) {
          $("html, body").removeClass("disable-scroll-notfixed");
        }
      })
    })

    $("#reviews").each(function() {
      var $t = $(this);
      var c = setInterval(function() {
        var $btn = $t.find(".spr-summary-actions-newreview");
        var $h = $(".product-header-wrapper");
        var $badge = $h.find(".spr-badge");
        var plugincontent = $("#shopify-product-reviews .spr-summary");
        var $rh = $(".reviews-header");

        if ($btn.length && $badge.length && plugincontent) {
          // loaded
          clearInterval(c);
          var o = $("#shopify-product-reviews");
          var n = o.find(".spr-summary");


          $rh.find(".reviews-header__section").first().append(n);
          var i = $rh.find(".spr-summary-actions");
          $rh.find(".reviews-header__section").last().append(i);

          setTimeout(function() {

            if ($badge.find(".spr-badge-starrating").length) {
              // reviews exist
              $badge.find(".spr-badge-caption").addClass("accent-hover").click(function(e) {
                var top = $("#reviews").offset().top - S.size.header;
                window.scrollTo({
                  top: top,
                  behavior: 'smooth'
                });
              })
            }


            $(".spr-summary-actions-newreview").click(function(e) {
              e.preventDefault();
              var $p = $(this).parents(".reviews-section").first().find(".spr-form");
              S.scroll.disable($p.find("[body-scroll-lock-ignore]"));


              if (!$p.find(".overlay-blur").length) {
                $p.prepend('<button class="overlay-blur skip-btn-style"><span class="displace">Close</span></button>');
                $p.find(".new-review-form").prepend('<button class="sm-x-close skip-btn-style"><span class="displace">Close</span></button>');
                $p.find(".overlay-blur,.sm-x-close").click(function(e) {
                  e.preventDefault();
                  var $p = $(this).parents(".spr-form").first();
                  S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
                  $p.hide().removeClass("active");
                })
              }

              if (!$p.hasClass("active")) {
                $p.addClass("active").show();
              }
            });



            if ($badge.attr("data-rating") == "0.0") {
              $t.addClass("no-reviews hide");

              $h.find(".spr-starrating").remove();
              $h.find(".spr-badge-caption").html('<button class="link-btn skip-btn-style write-review">Write a Review</button>');
              var $btn2 = $h.find("button.write-review");
              $btn2.click(function(e) {
                $btn.trigger("click");
              })
            }

            $t.find(".spr-review-content-body").each(function() {
              if ($(this).text().length > 120) {
                $(this).after('<button class="skip-btn-style read-more type-e link-btn">Read More</button>');
              }
            })

            $t.find("button.read-more").click(function(e) {
              e.preventDefault();
              var $p = $(this).parents(".spr-review-content").first();
              if ($p.hasClass("expanded")) {
                $p.removeClass("expanded");
                $(this).text('Read More');
              } else {
                $p.addClass("expanded");
                $(this).text('Show Less')
              }
            })

            $t.find(".spr-reviews").after('<button class="outline read-all-reviews">Read All Reviews</button>');
            $t.find("button.read-all-reviews").click(function(e) {
              e.preventDefault();
              var $p = $(this).siblings(".spr-reviews");

              if ($p.hasClass("expanded")) {
                $p.removeClass("expanded");
                $(this).text('Read All Reviews');
              } else {
                $p.addClass("expanded");
                $(this).text('Show Less Reviews');
              }
            });

            if ($(".spr-review").length <= 3) {
              $(".read-all-reviews").hide();
            }

            $t.find(".new-review-form").submit(function(e) {
              var $form = $(this);
              console.log($form.attr("class"));
              var submittedTimer = setInterval(function() {
                var $form = $(".spr-form.active .new-review-form");
                var $r = $form.parents("#reviews").first();
                console.log("msg len: " + $form.find(".spr-form-message").length);
                if ($form.find(".spr-form-message").length) {
                  clearInterval(submittedTimer);
                  var $formContainer = $(".spr-form.active");
                  $formContainer.prepend('<button class="overlay-blur skip-btn-style"><span class="displace">Close</span></button>');
                  $formContainer.find(".new-review-form").prepend('<button class="x-close skip-btn-style"><span class="displace">Close</span></button>');
                  $formContainer.find(".overlay-blur,.x-close").click(function(e) {
                    e.preventDefault();
                    var $p = $(this).parents(".spr-form").first();
                    $p.hide().removeClass("active");
                  })
                }

              }, 20)
            })


            $badge.addClass("init");


            $t.removeClass("init");
          }, 100)



        }

      }, 100)
    })

    $(".nav .style-menu-tab").each(function(e) {
      $(this).click(function(e) {
        e.preventDefault();

        var $p = $(this).parent(".nav-item");
        if (!$p.hasClass("nav--active")) {
          var group = $(this).attr("data-group");
          var $t = $(".style-guide-grids");
          if ($t.length) {
            $p.siblings(".nav--active").removeClass("nav--active");
            $p.addClass("nav--active");
            if (group == "all") {
              $t.find(".style-guide-grid").show();
            } else {
              $t.find(".style-guide-grid:not(." + group + ")").hide();
              $t.find(".style-guide-grid." + group).show();
            }

          }
        }

      })
    })


    // FILTERS
    $(".filter-main-toggle").click(function(e) {
      e.preventDefault();
      var $p = $(this).siblings(".filters__body").first();

      if ($(this).hasClass("active")) {
        S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
        $p.removeClass("active");
        $(this).removeClass("active");
      } else {
        S.scroll.disable($p.find("[body-scroll-lock-ignore]"));
        $p.addClass("active");
        $(this).addClass("active");
      }
    })

    S.content.makeFilterTags();

    $(".filters .overlay-blur, .filters .x-close").click(function(e) {
      e.preventDefault();
      $(this).parents(".filters").find(".filter-main-toggle").trigger("click");
    })

    $(".filter--sort .filter__item a").click(function(e) {
      e.preventDefault();
      // console.log("a lick????");
      var $btn = $(this).parents(".filters").find(".close-btn");
      setTimeout(function() {
        var url = $btn.attr("href");
          window.location.href = url;
      }, 100)

      // console.log($(this).parents(".filters").find(".close-btn").length);
      // $(this).parents(".filters").find(".close-btn").trigger("click");
    })


    $(".filter__item").click(function(e) {
      var $p = $(this).parents(".filters__body");

      if (!$(this).hasClass("filter__item--active")) {
        $(this).addClass("filter__item--active");
        $(this).siblings().removeClass("filter__item--active");
      } else {
        $(this).removeClass("filter__item--active");
      }

      S.content.makeFilterTags();
    })

    $(".filter-label").click(function() {
      var $p = $(this).parents(".filter").first();
      if ($p.hasClass("active")) {
        $p.removeClass("active");
        $(this).removeClass("active");
        $(".filters").removeClass("expanded");
      } else {
        $p.siblings().find(".filter-label.active").removeClass("active");
        $p.siblings().removeClass("active");
        $p.addClass("active");
        $(this).addClass("active");
        if ($p.hasClass("filter--size") || $p.hasClass("filter--color")) {
          $(".filters").addClass("expanded");
        } else {
          $(".filters").removeClass("expanded");
        }
      }
    })





    $('.quickshop-btn.desktop-only').mouseover(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".quickshop-marker").first();
        $p.addClass("active");
    })

    $('.quickshop-btn.device-only').click(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".quickshop-marker").first();
      console.log($p.attr("class"));
      if ($p.hasClass("active")) {
        $p.removeClass("active");
      } else {
        $p.addClass("active");
      }
    })



    $(".quickshop-marker").mouseleave(function(e) {
      e.preventDefault();
      $(this).removeClass("active");
    })

    $(".quickshop-hover-add").click(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".product-item").first();
      var $size = $p.find("input[name=size]:checked");
      if ($size.length) {
        var size = $size.attr("value");
        var $trigger = $p.find(".quick-add__button[data-size='"+size+"']");
        if ($trigger.length) {
          $trigger.trigger("click");
          $('.full-looks').removeClass('active');
          $('.custom-popup').removeClass('open-popup');
          $('.body--page-community').removeClass('popup-open');
        }
      }
    })



    if($('body').hasClass('body--page-community')){
      $(".shop-full-look[data-id]").click(function(e) {
        e.preventDefault();
        console.log($(this).parents('.swiper-container').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only'))
        var id = $(this).parents('.swiper-container').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only').attr("data-id");
        var $t = $(".full-looks[data-id='"+id+"']");
        console.log($t,id)
        S.scroll.disable($t.find("[body-scroll-lock-ignore]"))
        $t.addClass("active");
        //S.scroll.disable();
      })
    }
    else{
      $(".shop-full-look-placeholder").click(function(e) {
        $('.swiper-slide-active > .shop-look-item > .block-interior > .shop-full-look.desktop-only').click();
      })
      $(".shop-full-look[data-id]").click(function(e) {
        e.preventDefault();
//         console.log($(this).parents('.swiper-container').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only'))
        var id = $(this).attr("data-id");
        var $t = $(".full-looks[data-id='"+id+"']");
        console.log($t,id)
        S.scroll.disable($t.find("[body-scroll-lock-ignore]"))
        $t.addClass("active");
        //S.scroll.disable();
      })
    }
    
    

    $(".full-looks").each(function() {
      $(this).find(".overlay-blur, .x-close").click(function(e) {
        // S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
        S.scroll.enable()
        $(this).parents(".full-looks").first().removeClass("active");
      })
      $(this).find(".quickshop-hover-add").click(function(e) {
        var $p = $(this).parents(".full-looks");
        $p.removeClass("active");
        S.scroll.enable()
        // S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
      })
      $(this).find(".full-looks-add-all").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".full-looks");
        $p.find(".quickshop-hover-add").each(function() {
          $(this).trigger("click");
        })
        $('.full-looks').removeClass('active');
        $('.custom-popup').removeClass('open-popup');
        $('.body--page-community').removeClass('popup-open');
      })
    })

    $(".option-name-click").click(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".option");
      var $b = $p.first().find(".option-bucket");
      if ($b.hasClass("active")) {
        $(this).removeClass("active");
        $b.removeClass("active");
      } else {
        $b.addClass("active");
        $(this).addClass("active");
        $p.siblings(".option").find(".option-bucket.active").removeClass("active");
      }
    })

    $(".header").hoverIntent(function() {
      $(this).addClass("header--toggled");
    }, function() {
      $(this).removeClass("header--toggled");
    })

    $(".nav-item.with-subnav.top-level").hoverIntent(function() {
      $(this).find(".subnav").addClass("expanded");
    }, function() {
      $(this).find(".subnav").removeClass("expanded");
    })

    $(".nav-search").click(function(e) {
      e.preventDefault();
      var $h = $(".header, .header-wrapper");
      var $t = $h.find(".search-wrapper");
      if ($t.hasClass("active")) {
        $t.removeClass("active");
        $h.removeClass("search-open");
      } else {
        $t.addClass("active");
        $h.addClass("search-open");
        $('.search__input').focus();
      }
    })

    $(".search-wrapper .overlay-blur, .search-wrapper .sm-x-close").click(function(e) {
      e.preventDefault();
      $(this).parents(".search-wrapper").removeClass("active");
      $(".header,.header-wrapper").removeClass("search-open");
    })

    $(".search__clear").click(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".search-wrapper.mode--results");
      $p.find("input.search__input").attr("value", "").focus();
      $(this).remove();
      $p.siblings().remove();
      $p.find("form.search--results").siblings().addClass("invisible");
    })

    $(".page--cart .cart-item__quantity .item-quantity__button").click(function() {
      $(".cart-wrapper").addClass("faded");
      setTimeout(function() {
        $("button.cart__update").trigger("click");
      }, 20)
    })

    $(".mini-cart").find(".x-close,.overlay-blur").click(function(e) {
      e.preventDefault();


      var $t = $(this).parents(".mini-cart");
      // console.log("mini cart x close click!!! " + $t.attr("class"));
      $t.removeClass("active");
      $(".header, .header-wrapper, .collection").removeClass("mini-cart-open");
      // console.log("hi?")

    })

    $(".option__content").each(function() {
      $(this).find(".option__item").click(function() {
        $(this).parents(".option__content").first().find("button.option__name").trigger("click");
      })

      $(this).find("button.option__name").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".option__content").find(".dropdown-menu");
        if ($p.hasClass("active")) {
          $p.removeClass("active");
          $(this).removeClass("active");
        } else {
          $p.addClass("active");
          $(this).addClass("active");
        }
//         console.log($('body').hasClass('body--cart'))
      })
    })

    $(".order-form .swatch.colorway-link").click(function() {
      $("article.product").addClass("fade-out");
    })



    // between colorway links with zoom open, set cookie to auto-open zoom on the next page
    $(".product-zoom .colorway-link").click(function() {
      Cookies.set("showZoom", 'true');
    });

    var zoomCookie = Cookies.get("showZoom");
    if (zoomCookie == 'true' && $(".product-zoom").length) {
      $(".product .product-gallery-container [data-high-res-img]").first().trigger("click");
    }
    if (zoomCookie) {
      Cookies.remove("showZoom");
    }



    $(".tab[data-target]").click(function(e) {
      e.preventDefault();
      var id = $(this).attr("data-target");
      $(this).addClass("active");
      $(this).siblings(".active").removeClass("active");

      var $t = $("[data-tab-id='"+id+"']");
      $t.addClass("active");
      $t.siblings(".active").removeClass("active");
    })


    $(".col-toggles").each(function() {
      $(".toggle-two").click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          $(this).parents(".col-toggles").first().removeClass("init");
          $(this).siblings(".active").removeClass("active");
          $(this).addClass("active");
          $(".collection-grids").removeClass("col-four col-one").addClass("col-two");

          if (S.isTablet) {
            Cookies.remove("togglePreferenceTablet");
            // console.log("clear tablet toggle preference");
          } else if (S.isMobile) {
            Cookies.set("togglePreferenceMobile", 'toggle-two');
            // console.log("set mobile toggle preference: toggle-two");
          } else {
            Cookies.set("togglePreference", 'toggle-two');
            // console.log("set desktop toggle preference: toggle-two");
          }
        }

      })
      $(".toggle-one").click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          $(this).parents(".col-toggles").first().removeClass("init");
          $(this).siblings(".active").removeClass("active");
          $(this).addClass("active");
          $(".collection-grids").removeClass("col-four col-two").addClass("col-one");
          if (S.isMobile) {
            Cookies.remove("togglePreferenceMobile");
            // console.log("clear mobile toggle preference");
          } else if (S.isTablet) {
            Cookies.set("togglePreferenceTablet", 'toggle-one');
            // console.log("set tablet toggle preference: toggle-one");
          }
        }
      })
      $(".toggle-four").click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          $(this).parents(".col-toggles").first().removeClass("init");
          $(this).siblings(".active").removeClass("active");
          $(this).addClass("active");
          $(".collection-grids").removeClass("col-two col-one").addClass("col-four");
          Cookies.remove("togglePreference");
          // console.log("clear desktop toggle preference: toggle-one");
        }
      })

    //   console.log("isMObile: " + S.isMobile + " / " + Cookies.get("togglePreferenceMobile"));
      // console.log("isTablet: " +  S.isTablet + " / " + Cookies.get("togglePreferenceTablet"));
      // console.log("isDesktop: " + S.isDesktop + " / " + Cookies.get("togglePreference"));

      if (S.isTablet && Cookies.get("togglePreferenceTablet")) {
        // console.log("tablet toggle preference found: " + Cookies.get("togglePreferenceTablet"));
        $("."+Cookies.get("togglePreferenceTablet")).trigger("click");
      } else if (S.isMobile && Cookies.get("togglePreferenceMobile")) {
        // console.log("mobile toggle preference found: " + Cookies.get("togglePreferenceMobile"));
        $("."+Cookies.get("togglePreferenceMobile")).trigger("click");
      } else if (S.isDesktop && Cookies.get("togglePreference")) {
        // console.log("desktop toggle preference found: " + Cookies.get("togglePreference"));
        $("."+Cookies.get("togglePreference")).trigger("click");
      }
      else{
        $(".toggle-one").trigger("click");
      }
    })

    $(".collections-promo-insert").each(function() {
      if ($(this).find(".grid-item-promo")) {
        $(this).find(".grid-item-promo").unwrap();
      } else {
        $(this).remove();
      }
    })


    $(".careers-content__opportunity-content").each(function() {
      var $t = $(this).siblings(".careers-content__opportunity-title").first();
      var title = $t.find(".careers-content__opportunity-title-position").text();
      var location = $t.find(".careers-content__opportunity-title-location").text();

      var html = '<a href="mailto:get@argentwork.com?subject=Application for '+title+', '+location+'" class="btn accent apply-btn">Apply</a>';
      $(this).find(".share").before(html);
    })

    $("input[type=file].form-upload").each(function() {
      $(this).on("change", function(){
        if ($(this)[0].files && $(this)[0].files.length > 0 ) {
          $(this).addClass("uploaded");
          $(this).siblings(".filename").remove();
          $(this).after('<div class="type-e filename">'+$(this)[0].files[0].name+'</div>');
        } else {
          $(this).removeClass("uploaded");
          $(this).siblings(".filename").remove();
        }
      });
    })



    $(".klaviyo_submit_button").click(function(e) {
      var $f = $(this).parents("form").first();
      $f.find("input[required]").each(function() {
        var val = $(this).val();

        if (val.trim() == "") {
          $(this).addClass("error").after('<span class="error-message type-e">Required</span>');
        }
        else {
          if ($(this).attr('type') == 'email' && !validateEmail(val)) {
            $(this).addClass("error").after('<span class="error-message type-e">Invalid Email</span>');
          }
          else if ($(this).attr('type') == 'text' && !validatePostalCode(val)) {
            $(this).addClass("error").after('<span class="error-message type-e">Invalid Postal Code</span>');
          }
          else {
            $(this).removeClass("error");
            $(this).siblings(".error-message").remove();
          }
        }

        $(this).focus(function() {
          $(this).removeClass("error");
          $(this).siblings(".error-message").remove();
        })
      })
    })

    function validateEmail(e) {
        var re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return re.test(String(e).toLowerCase());
    }

    function validatePostalCode(e) {
        var re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        return re.test(e);
    }

    // Account Page Form Toggles

    //Initialize state dropdowns.
    var $addForm = $(".account-address-form");
    // new Shopify.CountryProvinceSelector('customer-addr-new-country', 'customer-addr-{{ address_id }}-province', {hideElement: 'account-form__province-new'});
    $addForm.each(function() {
        var add_id = $(this).attr("data-address-id");
        new Shopify.CountryProvinceSelector('customer-addr-' + add_id + '-country', 'customer-addr-' + add_id + '-province', {hideElement: 'account-form__province-' + add_id});
        //var defaultState = $('.province-select[data-default]').attr("data-default"); $('.province-select > option').each(function(){ if ('[value]' == defaultState){ $(this).attr('selected', 'selected'); } });
    });

    $('.province-select').prepend($('<option disabled selected value>State</option>'));
    $('.province-select').prop("selectedIndex", 0);

    $(".account-dashboard .edit-address").click(function() {
      $(".customer-account__address-new").hide();
      $(".customer-account__details").css('padding-bottom', '0' );
      $(".address__preview-full").hide();
      $(".address__actions").hide();
      $(".address__preview-edit-text").text('Edit Address').show();
    })
    $(".account-dashboard .cancel-edit").click(function() {
      $(".customer-account__address-new").show();
      $(".customer-account__details").css('padding-bottom', 'inherit' );
      $(".address__preview-full").show();
      $(".address__actions").show();
      $(".address__preview-edit-text").hide();
    })

    $(".customer-account__address-new button").click(function() {
      $(".customer-account__details").css('padding-bottom', '0' );
      $(".address__preview-full").hide();
      $(".address__actions").hide();
      $(".address__preview-edit-text").html('Add Address').show();
      $(this).hide();
    })

    $(".save-address + button").click(function() {
      $('.customer-account__address-new button').show();
    })


    // intro loader vs. not
    if ($("body").hasClass("body--index")) {
      S.loader.init();
    } else {
      $("body").removeClass("init");
      S.content.cookieBar();
      setTimeout(function() {
        S.content.emailPop();
      }, 600)
    }





    /*
    var headerHeight = $(".header").outerHeight();
    console.log("headerHeight: " + headerHeight);

    var watchers = $('.scrollfix').map(function(i, element) {
    var watcher = scrollMonitor.create( element, headerHeight );
    watcher.lock();
    watcher.stateChange(function() {
      $(element).toggleClass('fixed', this.isAboveViewport)
    });
    return watcher;
  }); */
    $("#page-content").removeClass("init");
  }





  S.init = function() {
    // console.log("init");
    var $c = $("#page-content");



    // S.nav.init();
    S.scroll.action();
    $(window).bind("scroll", S.scroll.action);

    S.size.all();
    S.content.init($c);

    // $(".mini-cart").removeClass("active");

    setTimeout(function() {
      S.size.all();
      $(window).resize(function() {
        S.resizeTimer && clearTimeout(S.resizeTimer);
        S.resizeTimer = setTimeout(S.size.all, 300);
      });


      if ($(".collection-nav-wrapper").length) {
        S.scroll.collectionWatcher = scrollMonitor.create($(".collection-nav-wrapper"), S.size.header);
        S.scroll.collectionWatcher.lock();
        if (S.scroll.collectionWatcher.isAboveViewport) {
          $(".collection.container").addClass('collection-nav-sticky');
        }
        S.scroll.collectionWatcher.stateChange(function() {
          $(".collection.container").toggleClass('collection-nav-sticky', this.isAboveViewport);
        });
      }


      if ($(".faq-content__categories").length) {
        S.scroll.collectionWatcher = scrollMonitor.create($(".faq-content__categories"), S.size.header);
        S.scroll.collectionWatcher.lock();
        if (S.scroll.collectionWatcher.isAboveViewport) {
          $(".support-interior").addClass('nav-sticky');
        }
        S.scroll.collectionWatcher.stateChange(function() {
          $(".support-interior").toggleClass('nav-sticky', this.isAboveViewport);
        });
      }


      if ($(".promo-bar").length) {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS) {
        	S.scroll.headerWatcher = scrollMonitor.create($(".promo-bar"), -36);
        }
        else {
        	S.scroll.headerWatcher = scrollMonitor.create($(".promo-bar"));
        }

        S.scroll.headerWatcher.lock();
        S.scroll.headerWatcherAction = function(t) {
          if (S.scroll.headerWatcher.isAboveViewport && !S.scroll.headerWatcher.isInViewport) {
            $(".header").removeClass("with-promo-bar");
          } else {
            $(".header").addClass("with-promo-bar");
          }
        }
        S.scroll.headerWatcherAction();
        S.scroll.headerWatcher.stateChange(function() {
          S.scroll.headerWatcherAction();
        });
      }


      S.scroll.productWatcher = scrollMonitor.create($(".product-lower"));
      S.scroll.productWatcher.lock();
      S.scroll.productWatcherAction = function(t) {
        if (S.scroll.productWatcher.isInViewport || S.scroll.productWatcher.isAboveViewport) {
          $(".product-info").addClass('product-info--notsticky');
        } else {
          $(".product-info").removeClass('product-info--notsticky');
        }
      }
      S.scroll.productWatcherAction();
      S.scroll.productWatcher.stateChange(function() {
        if (this.isInViewport || this.isAboveViewport) {
          $(".product-info").addClass('product-info--notsticky');
          $(".product-info .order-form").addClass('absolute');
        } else {
          $(".product-info").removeClass('product-info--notsticky');
          $(".product-info .order-form").removeClass('absolute');
        }
      });


      S.scroll.faqWatchers = [];
      var f = 2;
      $(".faq-content__category-link").click(function(e) {
        e.preventDefault();
        var id = $(this).attr("href");
        var top = $(id).offset().top + S.size.windowH*-0.4;
        window.scrollTo({
          top: top,
          behavior: 'smooth',
          block: 'center'
        });
      })

      $(".faq-content__category").each(function() {
        // console.log(f);
        S.scroll.faqWatchers[f] = scrollMonitor.create($("#questions-" + f), S.size.windowH*-0.5);
        // console.log("#questions-" + f);
        if (S.scroll.faqWatchers[f].isInViewport) {
          var id = $(this.watchItem).attr("id");
          var $tab = $(".faq-content__category-link[href='#"+id+"']");
          $tab.addClass("active");
          $tab.siblings(".active").removeClass("active");
        }
        S.scroll.faqWatchers[f].enterViewport(function() {
          var id = $(this.watchItem).attr("id");
          var $tab = $(".faq-content__category-link[href='#"+id+"']");
          $tab.addClass("active");
          $tab.siblings(".active").removeClass("active");
        });
        f++;
      })

      if ($(".expandable-text[id]").length) {
          var hash = window.location.hash;
          if (hash) {
            var $t = $(hash);
            if ($t.length) {
              var $e = $t.find(".expandable-title");
              $e.trigger("click");

              setTimeout(function() {
                console.log($t.offset().top);
                var top = $t.offset().top + S.size.windowH*-0.4;
                console.log("top: " + top);
                window.scrollTo({
                  top: top,
                  behavior: 'smooth',
                  block: 'top'
                });
              }, 80);

            }
          }
      }


    }, 100)


  }




  S.init();

});


 